/**
 * Created by Ning Jiang on 2021-06-22.
 */

import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {ElGordosRevengeLayers, Layers} from "../../../view/ElGordosRevengeLayers";
import {gsap, TimelineLite} from "gsap";
import {ElGordosRevenge} from "../../../ElGordosRevenge";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {ElGordosRevengeBackground} from "../../../view/ElGordosRevengeBackground";
import {BigWinParticles} from "../../../view/particles/BigWinParticles";

export class BigWinView {

    private _layer:StageLayer;
    private _effectSpine:PIXI.spine.Spine | null;
    private _levelSpine:PIXI.spine.Spine | null;
    private _levelContainer:PIXI.Container;
    private _particles:BigWinParticles;
    private _levelColor = [0x110403, 0x220403, 0x330403, 0x440403, 0x550403];

    constructor() {
        this._layer = ElGordosRevengeLayers.getLayer(Layers.BIG_WIN)!;
        this._levelContainer = new PIXI.Container();
        this._levelContainer.position.set(360, 360);
        this._layer.addChild(this._levelContainer);
        this._particles = new BigWinParticles();
        this._particles.position.set(360, 360);
    }

    public getLevelAnimation(level:number, duration:number, isEndLevel:boolean):TimelineLite {
        if(!this._effectSpine) {
            this._effectSpine = new PIXI.spine.Spine(ElGordosRevenge.assetLoader.getSpineAsset('bwEffect'));
            this._effectSpine.autoUpdate = true;
            this._effectSpine.position.set(360, 360);
        }
        if(!this._levelSpine) {
            this._levelSpine = new PIXI.spine.Spine(ElGordosRevenge.assetLoader.getSpineAsset('bw'));
            this._levelSpine.autoUpdate = true;
        }

        const levelName = `bw${level + 1}_in`;
        const tl = new TimelineLite();
        tl.add([
            ElGordosRevenge.background.dimScreen(0.8, 0.2, this._levelColor[level], this._layer),
            () => {
                ElGordosRevengeBackground.shakeStageChain();
                ElGordosRevenge.background.playBoostAnimation(true, 0);
                this._levelSpine!.state.setAnimation(0, levelName, false);
                this._levelContainer.addChild(this._levelSpine!);
                this._levelContainer.alpha = 1;
                this._layer.addChild(this._effectSpine!);
                this._effectSpine!.state.setAnimation(0, `effect`, false);
                this._layer.addChild(this._particles);
                this._particles.playLevel(level);
                this.playScreenBlood();
            }
        ]);
        tl.add(ElGordosRevenge.background.dimScreen(0.2, 0.2));
        tl.add(ElGordosRevenge.background.dimScreen(0.9, 0.2));
        tl.add(ElGordosRevenge.background.dimScreen(0.4, 0.2));
        tl.add(ElGordosRevenge.background.dimScreen(0.8, 0.2));

        if(level > 0) {
            tl.add(() => {
                this._levelSpine!.state.timeScale = 0;
            }, 0.2333);
            tl.add(() => {
                this._levelSpine!.state.timeScale = 1;
            }, 0.5333);
        }
        tl.add(() => {
            this._levelSpine!.state.setAnimation(0, `bw${level + 1}_idle`, true);
        }, this._levelSpine.spineData.findAnimation(levelName).duration + 0.5);
        return tl;
    }

    private playScreenBlood():void {
        const spine = new PIXI.spine.Spine(ElGordosRevenge.assetLoader.getSpineAsset("shootVFX"));
        spine.autoUpdate = true;
        spine.state.timeScale = 2;
        spine.position.set(360, 360);
        this._layer.addChild(spine);
        const shuffled = ArrayHelper.shuffle([1, 2, 3, 4, 5, 6]);
        const chosen = shuffled.slice(0, MathHelper.randomNumberInRange(2, 4));
        const tl = new TimelineLite();
        let delay = 0;
        chosen.forEach((ani, index) => {
            const aniName = `bloodSplash${ani}`;
            tl.add(() => {
                spine.state.setAnimation(index, aniName, false);
            }, delay);
            tl.add(() => {
                spine.state.setEmptyAnimation(index, 0);
            }, spine.spineData.findAnimation(aniName).duration * 2 + delay);
            delay += 0.2 + Math.random() * 0.4;
        });
        tl.add(() => {
            spine.state.setEmptyAnimations(0);
            spine.parent.removeChild(spine);
            spine.destroy();
        });
    }

    public playEnding(endLevel:number):void {
        this._particles.stop();
        const tl = new TimelineLite();
        if(endLevel > 1) {
            const name = `bw${endLevel + 1}_outro`;
            tl.add(() => {
                this._levelSpine!.state.setAnimation(0, name, false);
            },);
            tl.add(() => {}, this._levelSpine!.spineData.findAnimation(name).duration + 0.05);
        }

        if(ElGordosRevenge.model.parsedGameData.brokeTheBank) {
            tl.add(gsap.to(this._levelContainer, 0.7, {alpha : 0}), 0);
        } else {
            tl.add(ElGordosRevenge.background.dimScreen(0, 0.4), 0);
            tl.add(gsap.to(this._levelContainer, 0.2, {alpha : 0}), 0.4);
        }

        tl.add(() => {
            this._levelSpine?.state.setEmptyAnimations(0);
            this._levelContainer.removeChild(this._levelSpine!);
            this._levelSpine?.destroy();
            this._levelSpine = null;
            this._effectSpine!.state.setEmptyAnimations(0);
            this._layer.removeChild(this._effectSpine!);
            this._effectSpine!.destroy();
            this._effectSpine = null;
        });
    }
}